<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-03 13:14:11
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>通知管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">通知列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="标题">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入标题"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="停用" value="0"></el-option>
                    <el-option label="启用" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="title" label="标题" align="center">
          </el-table-column>
          <el-table-column prop="systemType" label="发送机型" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.systemType == 0
                  ? "所有"
                  : scope.row.systemType == 1
                  ? "IOS"
                  : "Android"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="推送分类" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.broadcastType == 0
                  ? "平台通知"
                  : scope.row.broadcastType == 1
                  ? "钱包通知"
                  : "任务通知"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="通道类型" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.channelType == 0
                  ? "极光推送"
                  : scope.row.channelType == 1
                  ? "环信IM"
                  : "短信"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="publishName" label="发布人" align="center">
          </el-table-column>
          <el-table-column label="是否定时" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.crontab == 0 ? "否" : "是" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发布时间" align="center" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.sendAt }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 0">停用</span>
              <span class="greenColor" v-if="scope.row.status == 1">启用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  启用
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  停用
                </div>
                <div
                  class="operateBtn"
                  @click="edit(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  编辑
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
        status: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "name",
          type: "input",
          value: this.ruleForm.name,
        });
      } else if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      this.$axios
        .post(`/admapi/broadcast/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    add() {
      this.$router.push("/noticeAdd");
    },
    edit(val) {
      this.$router.push({
        path: "/noticeAdd",
        query: {
          id: val.id,
        },
      });
    },
    stop(val) {
      this.$confirm(val.status == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.status == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/broadcast/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.status == 1 ? "禁用成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/broadcast/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
